var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "login" },
    [
      _c("div", { staticClass: "clearfix" }),
      _c(
        "form",
        {
          attrs: {
            method: "post",
            action: "api/ajax-login.php",
            id: "loginForm",
          },
        },
        [
          _c("div", { staticClass: "row" }, [
            _c(
              "div",
              {
                class: {
                  "col-12": true,
                  "col-sm-6": _vm.loginType == "simple",
                  "col-lg-6": _vm.loginType == "simple",
                },
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$v.email.$model,
                        expression: "$v.email.$model",
                      },
                    ],
                    class: {
                      "form-control": true,
                      "form-input-item": true,
                      "invalid-error": _vm.$v.email.$error,
                    },
                    attrs: { type: "text", placeholder: "E-mail cím" },
                    domProps: { value: _vm.$v.email.$model },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.$v.email, "$model", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
            _c(
              "div",
              {
                class: {
                  "col-12": true,
                  "col-sm-6": _vm.loginType == "simple",
                  "col-lg-6": _vm.loginType == "simple",
                },
              },
              [
                _c("div", { staticClass: "form-group" }, [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.$v.password.$model,
                        expression: "$v.password.$model",
                      },
                    ],
                    class: {
                      "form-control": true,
                      "form-input-item": true,
                      "invalid-error": _vm.$v.password.$error,
                    },
                    attrs: { type: "password", placeholder: "Jelszó" },
                    domProps: { value: _vm.$v.password.$model },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.$v.password, "$model", $event.target.value)
                      },
                    },
                  }),
                ]),
              ]
            ),
          ]),
          _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "button",
                {
                  staticClass: "button button-sm mb-2",
                  attrs: { type: "button" },
                  on: { click: _vm.submit },
                },
                [_vm._v("Belépek")]
              ),
              _c("br"),
              _c(
                "a",
                {
                  staticClass: "new-password",
                  on: { click: _vm.getNewPassword },
                },
                [_vm._v("Új jelszó igénylése")]
              ),
            ]),
          ]),
        ]
      ),
      _c("simplemodal", {
        attrs: {
          modal_title: _vm.modalData.title,
          modal_content: _vm.modalData.content,
          modal_id: _vm.modalData.key,
        },
      }),
      _c("new-password", {
        ref: "newpwd",
        on: { send: _vm.onSendNewPassword },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }